import React, { useEffect, useState } from "react";
import "./POIList.css";
import { RootState } from "../../../redux/reducers/root";
import { useSelector, useDispatch } from 'react-redux';
import { addNewPoi, getPOIList, removeNewPoi, removePOI } from "../../../redux/actions/nbhd/nbhd";
import { faHeart, faHouse, faLock, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { faHeart as farHeart } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {currencyFormat} from "../../../utils/helperFunction";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import { getSnapshotsListState, Snapshot, SnapshotCentroid } from "../../../redux/reducers/getSnapshotsListReducer/getSnapshotsListReducer";
import { useMap } from "react-map-gl";
import { POICudState } from "../../../redux/reducers/getNBHDReducer/getPOICudReducer";
import { NewPoiState } from "../../../redux/reducers/getNBHDReducer/getNewPoisReducer";
import IconButton from "../PoiIconButton/IconButton";
import { useTranslation } from "react-i18next";

export default function POIListInfo() {

    const { mainMap } = useMap();
    const { t } = useTranslation("nbhd"); 

    const snapshotsState = useSelector((state: RootState) => state.SnapshotsListReducer.SnapshotsList as getSnapshotsListState);
    const currentProp = useSelector((state: RootState) => state.propertyListReducer.currentProperty);
    const newPoiState = useSelector((state: RootState) => state.NBHDReducer.NewPoi as NewPoiState);
    const snapShotInfo = useSelector((state: RootState) => state.SnapShotReducer.snapShotInfo as getSnapShotState);

    const snapShotInfoData = snapShotInfo["snapShotInfo"]?.['data'];
    const currentSnapRoll = snapShotInfoData?.roll;


    // See if you can get redux store instead of localstorage 
    const currentRoll = currentProp["currentProperty"];
    const ownerType = currentProp["currentOwnerType"];
    const userProfileId = window.localStorage.getItem("userProfileId");

    const loading: boolean = snapshotsState.loading;

    const snapshots = snapshotsState.poiListDetail;
    const [poiList, setPoiList] = useState<Snapshot[]>([]);
    const dispatch = useDispatch();
    const poiCudState = useSelector((state: RootState) => state.NBHDReducer.POICud as POICudState);

    const FindPropOnMap = (centroid: SnapshotCentroid | null, roll: string) => {
        if (centroid){
             mainMap?.jumpTo({center:[centroid.lng,centroid.lat]}, {roll: roll});
        }
        else {
            console.log("no centroids for this property");
        }
    }

    const addNewPoiButton = (POI: Snapshot) => {
        if(POI.roll) {
            dispatch(addNewPoi(POI.roll));
        }
    }

    const removeNewPoiButton = (POI: Snapshot) => {
        if(POI.roll) {
            dispatch(removeNewPoi(POI.roll));
        }
    }

    const removePoi = (POI: Snapshot) => {
        dispatch(removePOI(userProfileId as string, currentRoll, POI.roll, ownerType));
        dispatch(removeNewPoi(POI.roll));
    }

    const getPOISales = (POI: Snapshot) => {
        const poisales = POI.details?.sales;
        let sales: string;
        if (!poisales) {
            return "";
        } else {
            sales = poisales.sale_amt as string;
        }
        return sales;
    }

    const renderPOIList = () => {
        
        return (
            poiList.map((POI) => {
                let heartButton;
                let trashLockButton;
                if (parseInt(POI.reported) === 0) {
                    if (newPoiState.newPoi.includes(POI.roll)) {
                        heartButton = <IconButton icon={faHeart} onClick={e => removeNewPoiButton(POI)} hasTooltip={true} tooltipDirection={"right"} tooltipContent={t("nbhd.POI.heart-selected")} />;
                    } else {
                        heartButton = <IconButton icon={farHeart} onClick={e => addNewPoiButton(POI)} hasTooltip={true} tooltipDirection={"right"} tooltipContent={t("nbhd.POI.heart-deselected")} />;
                    }
                    trashLockButton = <IconButton icon={faTrashCan} onClick={e => removePoi(POI)} hasTooltip={true} tooltipDirection={"left"} tooltipContent={t("nbhd.POI.trash-tip")} usePending={true}/>;
                } else {
                    heartButton = <IconButton icon={faHeart} hasTooltip={true} tooltipDirection={"right"} tooltipContent={t("nbhd.POI.heart-selected")}  />;
                    trashLockButton = <FontAwesomeIcon icon={faLock} />;
                }
                return (
                    <div className="row rowlist" key={POI.roll}>
                        <div className={`favourites-row-content-list ${(currentSnapRoll === POI.roll) && "selected"}`} onClick={e => FindPropOnMap(POI.centroid, POI.roll)}>
                            <div className="favourites-heart-image" >         
                                {heartButton}
                            </div>
                            <div className="favourites-row-image-list" >
                                <FontAwesomeIcon icon={faHouse} size="3x" color="#a3a3a396"/>
                            </div>
                            <div className="favourites-row-detail">
                                <p className="property-address blue text-uppercase">
                                    <span className="address-name">{POI.details?.addr}</span>
                                    <span className="address-lock-remove">
                                        {trashLockButton}
                                    </span>
                                </p>
                                <p className="cva-container">
                                    <span className="cva-header">CVA</span>
                                    <span className="cva-value">{currencyFormat(parseInt(POI.details?.cva as string))}</span>
                                </p>
                                <p className="sales-container">
                                    <span className="empty"></span>
                                    <span className="sales">{currencyFormat(parseInt(getPOISales(POI)))}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                );
            })

        );
    }

    useEffect(() => {
        // Only want to dispatch if
        // No data exists 
        // or The data is no longer associated to the current selected property

        if (!snapshotsState.loading && !snapshots) {
            currentRoll && userProfileId && ownerType && dispatch(getPOIList(userProfileId, currentRoll, ownerType));
        }
        if (snapshots) {
            const currRollData = snapshots["roll"];
            const poiList: Snapshot[] = snapshots['snapshots'].filter(snap => (snap['type'] === "POI"))
            setPoiList(poiList);
            if ((currRollData !== currentRoll) && !snapshotsState.loading) {
                currentRoll && userProfileId && ownerType && dispatch(getPOIList(userProfileId, currentRoll, ownerType));
            }
        }
    }, [currentRoll, userProfileId, dispatch, snapshotsState, snapshots, ownerType]);

    useEffect(() => {
        if (poiCudState.success) {
            dispatch(getPOIList(userProfileId as string, currentRoll, ownerType))
        }
    }, [poiCudState, dispatch, userProfileId, currentRoll, ownerType]);


    // useEffect(() => {
    //     // setPoiList(poiList)
    // }, [newPoiState])
    return <>
        <AmpLoadingSpinner loading={loading}>
            <div className="list-group">
                {
                    renderPOIList()
                }
            </div>
        </AmpLoadingSpinner>
    </>
}

